export default __webpack_public_path__ + "static/media/image-banner-biblio.419534cb.png";